import { render } from "./ProjectsApartments.vue?vue&type=template&id=775d7e54"
import script from "./ProjectsApartments.vue?vue&type=script&lang=js"
export * from "./ProjectsApartments.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__